import loading from "../../config/loading.json"
import videoLoading from "../../config/youtube-loading.json"
import uploadLoading from "../../config/upload.json"
import arrowLoading from "../../config/arrow.json"

import { Backdrop } from "@material-ui/core";
import IMAGES from "../../config/images";
import useWindowSize from "../../helper/hooks/useWindowSize";
import { useLottie } from "lottie-react";

export function Loading(props: any) {
  const options:any = {
    animationData: loading,
    loop: true,
    autoplay: true,
  };
  const { View } = useLottie(options);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={props.style ? props.style : { width: 70, height: 70 }}>
        {View}
      </div>
    </div>
  );
}

export function SearchLoading(props: any) {
  const options:any = {
    animationData: loading,
    loop: true,
    autoplay: true,
  };
  const { View } = useLottie(options);
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={props.style ? props.style : { width: 40, height: 40 }}>
        {View}
      </div>
    </div>
  );
}

export function UploadLoading(props: any) {
  const options:any = {
    animationData: uploadLoading,
    loop: true,
    autoplay: true,
  };
  const { View } = useLottie(options);
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={props.style ? props.style : { width: 170, height: 170 }}>
        {View}
      </div>
    </div>
  );
}

export function BackDropAnalyzeLoading(props: any) {
  const { width } = useWindowSize();
  return (
    <div className="loader">
      <Backdrop open={props.loading ? true : false}>
        <img src={IMAGES.v2_loader} style={{ width: (width ? width : 1600) / 4 }} alt={'img'} />
      </Backdrop>
    </div>);
}

export function VideoLoading() {
  const options:any = {
    animationData: videoLoading,
    loop: true,
    autoplay: true,
  };
  const { View } = useLottie(options);
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ width: 140, height: 140 }}>
        {View}
      </div>
    </div>
  );
}

export function ArrowLoading() {
  const options:any = {
    animationData: arrowLoading,
    loop: true,
    autoplay: true,
  };
  const { View } = useLottie(options);
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ width: 140, height: 140 }}>
        {View}
      </div>
    </div>
  );
}